import { Alert, Dialog, Stack, TextField } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import type { TopicDatabase } from '../../../../types';
import { useCreateUpdateTopicModal } from './useCreateUpdateTopicModal';

type Props = {
  /** The topic to rename. Omit to create a new one. */
  topic?: TopicDatabase;
  onClose: () => void;
  onCreated?: (topic: TopicDatabase) => void;
};

export default function CreateUpdateTopicModal(props: Props) {
  const hook = useCreateUpdateTopicModal(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      onSubmit={hook.onSubmit}
      maxWidth="xs"
      fullWidth
      title={props.topic ? 'Modifier le sujet' : 'Nouveau sujet'}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: props.topic ? 'Enregistrer' : 'Créer',
          type: 'submit',
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={3}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          name="name"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom du sujet"
              placeholder="Travaux, Entretien courant…"
              autoFocus
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
}
